// uses first month at 1 (not zero)
import { format } from '@fs/zion-locale/date-fns'

const localizedDate = 'PPP'

// Special parsing and formatting for profile birthDate since the backend requires a 3 letter English month
// Example: '24 Jul 1847'
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const emptyBirthDate = Object.freeze({
  day: '',
  month: '',
  year: '',
  text: '',
})

export function formatBirthDate(birthDate) {
  if (!birthDate) {
    return emptyBirthDate
  }
  const [day, monthEnglish, year] = birthDate.split(' ')
  const dayNumber = +day
  const yearNumber = +year
  const monthNumber = months.indexOf(monthEnglish)
  if (monthNumber === -1 || Number.isNaN(dayNumber) || Number.isNaN(monthNumber) || Number.isNaN(yearNumber)) {
    return emptyBirthDate
  }
  return {
    // parse back as string to ensure no left padding with '0'
    day: String(dayNumber),
    month: String(monthNumber + 1),
    year,
    text: format(new Date(yearNumber, monthNumber, dayNumber), localizedDate),
  }
}

export function parseBirthDate(birthDate) {
  if (!birthDate) {
    return undefined
  }
  const { day, month, year } = birthDate
  if (!day || !month || !year) {
    // do not return empty string here as that could break CIS if we send an empty string
    // for a birthDate that does not exist in CIS
    return undefined
  }
  const monthEnglish = months[+month - 1]
  return `${day} ${monthEnglish} ${year}`
}
